import fetch from 'isomorphic-fetch';
import * as ActionType from './types/DashboardActionTypes';

function requestDashboard() {
  return {
    type: ActionType.REQUEST_DASHBOARD
  };
}

function receiveDashboard(json) {
  return {
    type: ActionType.RECEIVE_DASHBOARD,
    payload: json
  };
}

export function fetchDashboard() {
  return (dispatch) => {
    dispatch(requestDashboard());
    return fetch('/web-api/v1/weddingaccount/dashboard',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveDashboard(json)));
  };
}

export function fetchInvites() {
  return (dispatch) => {
    dispatch(requestDashboard());
    return fetch('/web-api/v1/weddingaccount/dashboard',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveDashboard(json)));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/DashboardActions.js
 **/